import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../../../../ui';
import { Shadows } from '../../../../../ui/Standards';
import { Flexer, Title } from '../../../../dashboard/elements/LayoutElements';
import { useSingleSignOnForm, useSingleSignOnMutation } from '../SingleSignOnHooks';

const SetupStepFrame = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1.5rem;
    box-shadow: ${Shadows.md};
    border-radius: .25rem;
    border-left: .25rem solid ${Colors.primary};
    background: white;
    overflow: hidden;
`;

export const SetupStep = React.memo(({ title, children }: { title: string, children: React.ReactNode }) => {
    return <SetupStepFrame>
        <Title flush color={Colors.text}>{title}</Title>
        <Flexer padding=".5 0 0 0" flex="column" gap="1">
            {children}
        </Flexer>
    </SetupStepFrame>;
});

export interface StepProps {
    form: ReturnType<typeof useSingleSignOnForm>;
    mutation: ReturnType<typeof useSingleSignOnMutation>;
    currentStep: number;
    gotoStep: (step: number | 'end') => void;
}
